module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal11-607bf293a18db4c9277f6153e5b517a6.jpg";